import { useLanguage } from './i18n';

function LanguageSwitcher() {
  const { language, setLanguage, messages } = useLanguage();

  return (
    <div className="language-switcher" aria-label={messages.language}>
      {['ru', 'en'].map((item) => (
        <button
          type="button"
          className={language === item ? 'is-active' : ''}
          aria-pressed={language === item}
          onClick={() => setLanguage(item)}
          key={item}
        >
          {item.toUpperCase()}
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitcher;
